//Custom Imports
import { vacationType } from "@reducers/actionTypes";
import { asyncActionCreator } from "./redux.action";

const getVacationDetails = asyncActionCreator(
  vacationType.GET_VACATION_DATA_UPCOMING,
  vacationType.GET_VACATION_DATA_SUCCESS,
  vacationType.GET_VACATION_DATA_ERROR,
  vacationType.GET_VACATION_DATA_FETCHED,
);

export default {
  getVacationDetails,
};
